<template>
  <div class="liveMatchesTwo">
    <Component
      :mathInfo="mathInfo"
      @focus="focus"
      @liveFinished="liveFinished"
      @startLive="startLive"
      @updateLiveInfo="updateLiveInfo"
      :recLive="recLive"
      :liveDetail="liveDetail"
      :anchor="anchor"
      :is="'UserRoom'"
      :categoryName="categoryName"
      :liveNotice="liveNotice"
      :userLocal="userLocal"
      :fans_count="fans_count"
      :recAnchor="recAnchor"
      :hotLives="hotLives"
      :isAnchor="isAnchor"
      :liveAd="liveAd"
      v-if="isHotLivesLoad"
    />
  </div>
</template>

<script>
import UserRoom from "./liveMatchesTwo_detail";
import { post } from "@/util/http";
import { mapState, mapMutations } from "vuex";

const titleObj = {
  onv2: "Xem Livestream - Trực Tiếp Miễn Phí | Xôi Lạc TV",
  "8on": "Xem bóng miễn phí không giật lag",
  sport247: "Xem bóng miễn phí không giật lag",
};
const descriptionObj = {
  onv2: "Thưởng thức các buổi livestream hấp dẫn MIỄN PHÍ trên Xôi Lạc TV! Phát trực tuyến, stream trực tuyến 24/7. Xem ngay các nội dung thú vị của Việt Nam!",
  "8on":
    "Thưởng thức các buổi livestream hấp dẫn MIỄN PHÍ trên Xôi Lạc TV! Phát trực tuyến, stream trực tuyến 24/7. Xem ngay các nội dung thú vị của Việt Nam!",
  sport247:
    "Hãy thưởng thức các buổi livestream hấp dẫn MIỄN PHÍ trên SPORT247!  Phát sóng liên tục 24/7, mang đến cho bạn những nội dung thú vị !",
};
const keywordsObj = {
  onv2: "phát trực tiếp, stream trực tuyến, trực tiếp Việt Nam, xem livestream",
  "8on":
    "phát trực tiếp, stream trực tuyến, trực tiếp Việt Nam, xem livestream",
  sport247:
    "phát trực tiếp, stream trực tuyến, trực tiếp Việt Nam, xem livestream",
};

export default {
  metaInfo() {
    return {
      title: titleObj[SITE],
      meta: [
        {
          name: "description",
          content: descriptionObj[SITE],
        },
        {
          name: "keywords",
          content: keywordsObj[SITE],
        },
      ],
    };
  },
  name: "live-detail",
  components: {
    UserRoom,
    // AnchorRoom,
  },
  data() {
    return {
      recLive: [],
      liveDetail: {
        pull_url: "",
        title: "",
        categoryid: null,
        start_stamp: 0,
      },
      // recLive: "",
      anchor: {},
      isAnchor: false,
      recAnchor: {},
      downloadUrl: "",
      fans_count: 0,
      hotLives: [],
      isHotLivesLoad: false,
      category_name: "",
      isLiveDataLoad: false,
      liveNotice: "暂无公告",
      mathInfo: {},
      liveAd: "",
      categoryName: "",
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  async created() {},
  async mounted() {
    await this.liveFinished();
    await this.getHotLives();
    // await this.getRecAnchor();
    // console.log(this.$route.params.id);
  },
  destroyed() {
    if (this.hotLiveTime) {
      clearTimeout(this.hotLiveTime);
    }
  },
  methods: {
    ...mapMutations([
      "changeLiveAd",
      "changeLiveAdContact",
      "changeLiveAdContactMain",
      "changeAnchorId",
      "changeIsFollowed",
    ]),

    focus(count) {
      this.$set(this.anchor, "isattent", !this.anchor.isattent);
      this.fans_count = count;
    },
    startLive(data) {
      this.liveDetail = {
        ...data,
        hot: 0,
      };
    },
    async visitRecord(id) {
      await post({
        url: "/api/live/visit_record",
        data: {
          live_id: id,
        },
      });
    },
    setContactAds(data) {
      const arr = [];
      const obj1 = {
        title: data.contact_name_1,
        value: data.contact_address_1,
      };
      const obj2 = {
        title: data.contact_name_2,
        value: data.contact_address_2,
      };
      const obj3 = {
        title: data.contact_name_3,
        value: data.contact_address_3,
      };
      arr.push(obj1);
      arr.push(obj2);
      arr.push(obj3);
      this.changeLiveAdContact(arr);
      this.changeLiveAdContactMain(data.main_content);
    },
    async liveFinished() {
      try {
        const {
          data: { data },
        } = await post({
          url: "/webapi/live/getLivePageData",
          data: {
            anchorid: parseInt(this.$route.params.id),
            uid: parseInt(this.userInfo.id) || 0,
          },
        });
        this.setContactAds(data);
        this.changeLiveAd(data.live_notice);
        this.changeIsFollowed(data.anchor.isattent);
        this.recLive = data.rec_lives;
        this.liveDetail = data.live || {};
        this.changeAnchorId(this.liveDetail.anchorid || data.anchor.id);
        this.anchor = data.anchor;
        this.isAnchor = this.userInfo.id === data.anchor.id;
        this.fans_count = data.fans_count;
        this.liveNotice = data.live_notice;
        this.userLocal = data.live.anchorid;
        this.categoryName = data.category_name;
        if (
          this.liveDetail.ticket > 0 &&
          this.liveDetail.ticket_paid === 2 &&
          this.userInfo.id !== this.liveDetail.anchorid
        ) {
          this.$router.push("/home");
        }
        if (data.math) {
          this.mathInfo = data.math;
        }
        if (this.userInfo.id && data.live.liveid) {
          await this.visitRecord(data.live.liveid);
        }
        // this.isLiveDataLoad = true;
        // this.$forceUpdate();
      } catch (e) {}
    },
    async getRecAnchor() {
      let { matchid: mid } = this.liveDetail;
      const {
        data: { data: recAnchor },
      } = await post({
        url: "/api/sport/getMatch",
        data: {
          matchid: mid || parseInt(this.$route.params.id),
          sport_type: this.liveDetail.categoryid === 1 ? "football" : "",
        },
      });
      this.recAnchor = recAnchor;
    },
    async getHotLives() {
      const {
        data: { data },
      } = await post({
        url: "/api/live/getLiveList",
        data: {
          uid: this.userInfo.id || 0,
        },
      });
      // let live = data.data;
      // if (live.length > 8) {
      //   live = live.slice(0, 8);
      // }
      // this.hotLives = live;
      this.hotLives = data?.slice(0, 8);
      this.isHotLivesLoad = true;
    },
    updateLiveInfo() {
      console.log(
        this.$route.params.id,
        this.$store.state.userInfo.id,
        "update live info is ok !!!"
      );
      post({
        url: "/webapi/live/getLivePageData",
        data: {
          anchorid: parseInt(this.$route.params.id),
          uid: this.$store.state.userInfo.id
            ? this.$store.state.userInfo.id
            : 0,
        },
      }).then(({ data }) => {
        this.liveDetail = data.data.live || {};
        // 后端还未设计好如何更新比赛信息的逻辑，暂时不处理
        // const {category, sport_type} = data.data.live || {}
        // if(category === 2 && sport_type === "football"){
        // }

        this.anchor = data.data.anchor;
        this.recLive = data.data.rec_lives || [];
        this.fans_count = data.data.fans_count;
        this.isAnchor = this.$store.state.userInfo.id === data.data.anchor.id;
        this.getHotLives();
      });
    },
  },
};
</script>

<style scoped lang="scss">
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease-in-out;
}

.slide-enter,
.slide-leave-to {
  transform: translate3d(0, -70%, 0) scale(0.1);
  opacity: 0;
}

.liveMatchesTwo {
  width: 100%;
  // height: 10.24rem;
  box-sizing: border-box;
  padding-top: 0.66rem;
  overflow: hidden;
}
</style>
